import { BrowserRouter, Navigate, Route, Routes, useLocation} from 'react-router-dom';
import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Login from './Pages/Login';
import CustomNavbar from './Components/Navbar';
import Dashboard from './Pages/Dashboard';
import AddVendor from './Pages/AddVendor';
import ViewVendor from './Pages/ViewVendor';
import AddDeliveryVendor from './Pages/AddDeliveryVendor';
import AddIndependentDelivery from './Pages/AddIndependentDelivery';
import PromoCode from './Pages/PromoCode';
import { AddOfferes } from './Pages/AddOfferes';
import CustomizeField from './Pages/CustomizeField';
import ViewDeliveryVendor from './Pages/ViewDeliveryVendor';
import ViewIndependentDelivery from './Pages/ViewIndependentDelivery';
import ViewOffers from './Pages/ViewOffers';
import ViewDeliveryAgentEarnings from './Pages/ViewDeliveryAgentEarnings';
import AddDeliveryAgentEarnings from './Pages/AddDeliveryAgentEarnings';
import Settings from './Pages/Settings';
import AddProductsImage from './Pages/AddProductsImage';
import AddProducts from './Pages/AddProducts';
import ViewOrders from './Pages/ViewOrders';
import ViewPromoCode from './Pages/ViewPromoCode';
import { UpdateOffers } from './Pages/UpdateOffers';
import UpdateProductVendor from './Pages/UpdateProductVendor';
import { AddBanner } from './Pages/AddBanner';
import ViewBanners from './Pages/ViewBanners';
import {UpdateBanner} from './Pages/UpdateBanner';
import ViewProductImage from './Pages/ViewProductImage';
import ViewCategoryImage from './Pages/ViewCategoryImage';
import ViewProducts from './Pages/ViewProducts';
import AddStock from './Pages/AddStock';
import ViewStocks from './Pages/ViewStocks';
import UpdateProduct from './Pages/UpdateProduct';
import ViewCustomers from './Pages/ViewCustomers';
import ViewSubCategories from './Pages/ViewSubCategories';
import AddPriceHeads from './Pages/AddPriceHeads';
import ViewPriceHeads from './Pages/ViewPriceHeads';
import UpdatePromoCode from './Pages/UpdatePromoCode';
import UpdatePriceHeads from './Pages/UpdatePriceHeads';
import UpdateIndependentDelivery from './Pages/UpdateIndependentDelivery';
import UpdateDeliveryVendor from './Pages/UpdateDeliveryVendor';
import MyProvider from './Components/Context';
import UpdateDeliveryAgentEarnings from './Pages/UpdateDeliveryAgentEarnings';
import AddEmployee from './Pages/AddEmployee';
import ViewEmployee from './Pages/ViewEmployee';
import UpdateEmployee from './Pages/UpdateEmployee';
import PriceHeads from './Pages/priceheadssss';
import PriceHeadsDisplay from './Pages/PriceHeadsDisplay';
import ForgotPasswordResetPassword from './Components/ForgotPasswordResetPassword';
import ViewRaisedTickets from './Pages/ViewRaisedTickets';
import Chat from './Pages/Chat';
// import ViewDeliveryVendorAgent from './Pages/ViewDeliveryVendorAgent';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Customize_Css/Toasts.css";


function App() {
  return (
    <div className="App">
      <BrowserRouter>
      <MyProvider>
         <ToastContainer
          position="top-right"
          autoClose={2200}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      <MainLayout/>
    <div style={{display:'flex',flexDirection:'column',width:'100%',minWidth:0}}>
      <div>
      </div>
      <div style={{ display: 'flex', minHeight: '100vh', width: '100%', minWidth: 0, alignItems: 'flex-start', background: 'linear-gradient(to right, #006d5b 300px, transparent 300px)' }}>
            <AppRoutes />
            </div>
          </div>
          </MyProvider>
      </BrowserRouter>
    </div>
  );
}

function AppRoutes() {
  const location = useLocation();
  const token = localStorage.getItem('token');
  const role = localStorage.getItem('role');
  const isPublic = location.pathname === '/' || location.pathname === '/forgot-password';

  if (!token && !isPublic) {
    return <Navigate to="/" replace />;
  }

  if (token && location.pathname === '/') {
    return <Navigate to={role === 'employee' ? '/view-orders' : '/dashboard'} replace />;
  }

  return (
            <Routes>
              <Route path='/' element={<Login />} />
              <Route path='/dashboard' element={<Dashboard />} />
              <Route path='/addvendor/:epicxTenantId' element={<AddVendor/>} />
              <Route path='/viewvendor/:epicxTenantId' element={<ViewVendor/>}/>
              <Route path='/add-delivery-vendor' element={<AddDeliveryVendor/>}/>
              <Route path='/add-independent-delivery-person' element={<AddIndependentDelivery/>}/>
              <Route path='/addpromocode/:epicxTenantId' element={<PromoCode/>}/>
              <Route path='/addpriceheads/:epicxTenantId' element={<AddPriceHeads/>}/>

              <Route path='/addoffer' element={<AddOfferes/>}/>
              <Route path='/customize-field' element={<CustomizeField/>}/>
              <Route path='/view-delivery-vendor' element={<ViewDeliveryVendor/>}/>
              <Route path='/view-delivery-vendor-agents' element={<AddDeliveryVendor/>}/>
              <Route path='/add-delivery-agent' element={<AddDeliveryVendor/>}/>
              <Route path='/update-delivery-agent/:id' element={<AddDeliveryVendor/>}/>
              {/* <Route path='/view-delivery-vendor-agents' element={<ViewDeliveryVendorAgent/>}/> */}

              <Route path='/view-independent-delivery' element={<ViewIndependentDelivery/>}/>
              <Route path='/view-offer' element={<ViewOffers/>}/>
              <Route path='/view-delivery-earnings' element={<ViewDeliveryAgentEarnings/>}/>
              <Route path='/add-delivery-earnings' element={<AddDeliveryAgentEarnings/>}/>
              <Route path='/settings' element={<Settings/>}/>
              <Route path='/Add-product-image' element={<AddProductsImage/>}/>
              <Route path='/Add-product' element={<AddProducts/>}/>
              <Route path='/view-orders' element={<ViewOrders/>}/>
              <Route path='/view-promocode' element={<ViewPromoCode/>}/>
              <Route path='/view-priceHeads' element={<ViewPriceHeads/>}/>

              <Route path='/updateOffers/:id' element={<UpdateOffers/>}/>
              <Route path='/updatevendor/:id' element={<UpdateProductVendor/>}/>
              <Route path='/updatePromoCode/:id' element={<UpdatePromoCode/>}/>
              <Route path='/updatePriceHeads/:id' element={<UpdatePriceHeads/>}/>
              <Route path='/updateIndependentDelivery/:id' element={<UpdateIndependentDelivery/>}/>
              <Route path='/updateDeliveryVendor/:id' element={<UpdateDeliveryVendor/>}/>

              <Route path='/add-banners' element={<AddBanner/>}/>
              <Route path='/viewBanners' element={<ViewBanners/>}/>
              <Route path="/update-banner/:id" element={<UpdateBanner/>} />
              <Route path="/update-earnings/:id" element={<UpdateDeliveryAgentEarnings/>} />
              <Route path='/viewProductImage' element={<ViewProductImage/>}/>
              <Route path='/viewCategoryImage' element={<ViewCategoryImage/>}/>
              <Route path='/viewSubCategoryImage' element={<ViewSubCategories/>}/>
              <Route path='/viewProducts' element={<ViewProducts/>}/>
              <Route path='/Add-Stock' element={<AddStock/>}/>
              <Route path='/viewStocks' element={<ViewStocks/>}/>
              <Route path='/UpdateProducts/:vendorName/:productId' element={<UpdateProduct/>}/>
              <Route path='/viewCustomer' element={<ViewCustomers/>}/>
              <Route path='/add-employee' element={<AddEmployee/>}/>
              <Route path='/view-employee' element={<ViewEmployee/>}/>
              <Route path='/update-employee/:id' element={<UpdateEmployee/>}/>
              <Route path='/pricee' element={<PriceHeads/>}/>
              <Route path='/priceeview' element={<PriceHeadsDisplay/>}/>

              <Route path='/viewTickets' element={<ViewRaisedTickets/>}/>
              <Route path='/chat' element={<Chat/>}/>


              <Route path="/forgot-password" element={<ForgotPasswordResetPassword />} />

            </Routes>
  );
}

const MainLayout = ({ children }) => {
  const location = useLocation();
  const hideHeaderPaths = ['/', '/forgot-password']; 

  return (
    <>
      {!hideHeaderPaths.includes(location.pathname) && <CustomNavbar />}
      {children}
    </>
  );
};



export default App;
